export const cookie = (
  name: string,
  value: string | undefined = undefined
): string | null => {
  if (value !== undefined) {
    document.cookie = `${name}=${value}`;
  }

  let cookie = null;
  document.cookie.split(";").forEach((c: string) => {
    const [key, value] = c.split("=");
    if (key === name && value !== undefined) {
      cookie = value;
    }
  });

  return cookie;
};

export const invalidateToken = () => {
  document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
};
